exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Spacer___1c3sH {\n  flex: 1;\n}\n", ""]);

// exports
exports.locals = {
	"Spacer": "Spacer___1c3sH"
};